import React from "react";
import { Link } from "react-router-dom";
import topLeftImage from "../assets/top_left_image.png";
import boasterpurple from "../assets/mitkoboasterpurple.png";
import boasterwhite from "../assets/mitkoboasterwhite.png";
import banner1 from "../assets/mitkobanner1.png";
import bottom_center_image from "../assets/bottom_center_image.png";

const Home = () => {
  
  const handleScrollToTools = () => {
    const toolsSection = document.getElementById("tools");
    if (toolsSection) {
      toolsSection.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <>
      <div class="w-full relative bg-gradient pt-28 z-10">
        <div class="overlay-glow absolute top-52 right-64 z-[10]"></div>
        <img
          src={topLeftImage}
          alt="Top Left"
          width="650px"
          class="absolute top-0 left-0 z-10"
        />
        <div class="flex md:justify-between w-[90%] mx-auto justify-center items-center h-[85vh] flex-wrap font-primary">
          <div class="md:text-left text-center md:order-1 order-2 ml-0 md:ml-40 z-[30]">
            <span class="bg-gray-500 px-3 py-2 rounded-lg text-gray-900 font-medium">
              <span class="text-gray-950 font-medium">jacketrafa.Ai</span> -
              Unleash the power of Ai
            </span>
            <div class="flex flex-col md:justify-start justify-center mt-6">
              <div class="md:text-7xl text-4xl font-primary font-extrabold text-light">
                Ultimate AI
              </div>
              <div class="flex items-center md:justify-start justify-center mt-1">
                <span class="text-left md:text-7xl text-4xl font-primary font-extrabold primary-text-color">
                  Tools
                </span>
                <img
                  class="pl-2.5"
                  src={boasterpurple}
                  width="50px"
                  alt="boaster icon"
                />
              </div>
            </div>
            <p
              class="text-light mt-3 text-left opacity-50 font-primary"
              style={{
                maxWidth: "430px",
                lineHeight: "30px",
                wordSpacing: "1px",
              }}
            >
              jacketrafa is an AI platform that helps you to transcribe your
              audio and other files into text.
            </p>
            <button class="mt-6 bg-primary z-50 relative hover:bg-purple-500 duration-500 cursor-pointer py-3 px-16 rounded-lg md:mx-0 mx-auto flex justify-center items-center outline-none">
              <img
                src={boasterwhite}
                width="25px"
                alt="boaster icon"
                class="pr-2"
              />
              <span class="font-bold text-light font-primary" onClick={handleScrollToTools}>
                Try jacketrafa.Ai
              </span>
            </button>
            <p class="text-light mt-4 text-lg">
              <span class="opacity-50">Discover</span>
              <span class="opacity-80 pl-2">jacketrafa.ai</span>
            </p>
          </div>
          <div class="md:order-2 order-1 z-[20]">
            <img
              class="md:w-[750px] w-[300px] md:absolute bottom-[-30px] right-10 initial z-50"
              src={banner1}
              alt="mitkobanner"
              style={{
                maskImage: "linear-gradient(to top, transparent, black 10%)",
              }}
            />
          </div>
        </div>
        <img
          src={bottom_center_image}
          alt="Bottom Center"
          class="absolute bottom-0 left-1/2 transform -translate-x-1/2 z-10 image-container"
        />
      </div>

      <div class="bg-dark font-primary py-20 mb-28 mt-8" id="tools">
        <div class="w-[90%] mx-auto border border-gray-500 rounded-3xl p-14">
          <h2 class="text-5xl text-light font-primary font-bold text-center">
            <span class="primary-text-color">The future</span> is here.
          </h2>
          <div class="flex justify-center items-center flex-wrap">
            <Link className="no-underline" to={"/audio-transcribe"}>
              <div class="p-10 text-gray-700 hover:text-gray-200 duration-300 flex justify-center items-center flex-col mt-8 bg-light rounded-xl future-div">
                <svg
                  stroke="currentColor"
                  fill="currentColor"
                  stroke-width="0"
                  viewBox="0 0 24 24"
                  class="primary-color p-2 rounded-lg"
                  color="white"
                  height="40"
                  width="40"
                  xmlns="http://www.w3.org/2000/svg"
                  style={{ color: "white" }}
                >
                  <path fill="none" d="M0 0h24v24H0z"></path>
                  <path d="M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm2 11h-3v3.75c0 1.24-1.01 2.25-2.25 2.25S8.5 17.99 8.5 16.75s1.01-2.25 2.25-2.25c.46 0 .89.14 1.25.38V11h4v2zm-3-4V3.5L18.5 9H13z"></path>
                </svg>
                <h3 class="text-lg font-bold pt-2">Audio Transcribe</h3>
                <p class="w-60 text-center text-sm pt-1">
                  Transcribe and translate your any audio file into text using
                  ai
                </p>
              </div>
            </Link>
            <Link className="no-underline" to={"/voice-transcribe"}>
              <div class="p-10 text-gray-700 hover:text-gray-200 duration-300 flex justify-center items-center flex-col mt-8 mx-10 bg-light rounded-xl future-div">
                <svg
                  stroke="currentColor"
                  fill="currentColor"
                  stroke-width="0"
                  viewBox="0 0 1024 1024"
                  xmlns="http://www.w3.org/2000/svg"
                  height="40"
                  width="40"
                  class="primary-color p-2 rounded-lg"
                  style={{ color: "white" }}
                >
                  <path d="M512 624c93.9 0 170-75.2 170-168V232c0-92.8-76.1-168-170-168s-170 75.2-170 168v224c0 92.8 76.1 168 170 168zm330-170c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8 0 140.3-113.7 254-254 254S258 594.3 258 454c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8 0 168.7 126.6 307.9 290 327.6V884H326.7c-13.7 0-24.7 14.3-24.7 32v36c0 4.4 2.8 8 6.2 8h407.6c3.4 0 6.2-3.6 6.2-8v-36c0-17.7-11-32-24.7-32H548V782.1c165.3-18 294-158 294-328.1z"></path>
                </svg>
                <h3 class="text-lg font-bold pt-2">Voice Transcribe</h3>
                <p class="w-60 text-center text-sm pt-1">
                  Transcribe your voice recordings into text format with
                  assemblyAi
                </p>
              </div>
            </Link>
            <Link to="/pdf-to-text" className="no-underline">
              <div class="p-10 text-gray-700 hover:text-gray-200 duration-300 flex justify-center items-center flex-col mt-8 bg-light rounded-xl future-div">
                <svg
                  stroke="currentColor"
                  fill="currentColor"
                  stroke-width="0"
                  viewBox="0 0 24 24"
                  class="primary-color p-2 rounded-lg"
                  color="white"
                  height="45"
                  width="45"
                  xmlns="http://www.w3.org/2000/svg"
                  style={{ color: "white" }}
                >
                  <path fill="none" d="M0 0h24v24H0z"></path>
                  <path d="M20 2H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-8.5 7.5c0 .83-.67 1.5-1.5 1.5H9v2H7.5V7H10c.83 0 1.5.67 1.5 1.5v1zm5 2c0 .83-.67 1.5-1.5 1.5h-2.5V7H15c.83 0 1.5.67 1.5 1.5v3zm4-3H19v1h1.5V11H19v2h-1.5V7h3v1.5zM9 9.5h1v-1H9v1zM4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm10 5.5h1v-3h-1v3z"></path>
                </svg>
                <h3 class="text-lg font-bold pt-2">PDF Conversion</h3>
                <p class="w-60 text-center text-sm pt-1">
                  Convert you pdf file into a text file with the use of Ai
                </p>
              </div>
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default Home;
